import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {ContextService} from '@services/context.service';
import {takeUntil} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {Subject} from 'rxjs';
import {PrefillRegistrationModel, SelfRegistrationModel} from '@app/models/user-registration.model';
import {OrganizationService} from '@services/organizations.service';

@Component({
  selector: 'app-rapid-registration-page-3',
  templateUrl: './registration-page-3-address.component.html',
  styleUrls: ['./registration-page-3-address.component.scss'],
  imports: [
    SharedImports
  ]
})

export class RegistrationPage3AddressComponent implements OnInit, OnChanges {
  mainForm: FormGroup;

  isSaving: boolean = false;
  passwordType = 'password';
  passwordConfirmType = 'password';
  @Input() registrationProfile: SelfRegistrationModel;
  @Input() personPrefill: PrefillRegistrationModel;
  @Input() tenantName: string = 'iaff';
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() campaignId: number;
  legal = '';
  private ngUnsubscribe = new Subject();

  constructor(private formBuilder: FormBuilder,
              public contextService: ContextService, private organizationService: OrganizationService,
              private messageService: MessageService) {
    this.mainForm = this.formBuilder.group({
      password: new FormControl(null, [Validators.required,
        this.regexValidator(new RegExp('^.*[A-Za-z0-9$@#!%*?&].{9,}'), {length: true}),
        this.regexValidator(new RegExp('^.*[a-z]'), {lowercase: true}),
        this.regexValidator(new RegExp('^.*[A-Z]'), {uppercase: true}),
        this.regexValidator(new RegExp('^.*[0-9]'), {number: true}),
        this.regexValidator(new RegExp('^.*[$@#!%*?&]'), {special: true}),
        this.regexValidator(new RegExp('^(?!.*([a-zA-Z0-9$@#!%*?&])\\1{2,})'), {repeats: true})
      ]),
      // password: new FormControl('', [Validators.required,
      //   Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])(?!.*([a-zA-Z0-9])\\1{2,})[A-Za-zd$@$!%*?&].{9,}')]),
      showPassword: new FormControl(false),
      passwordConfirm: new FormControl(null, Validators.required),
      showPasswordConfirm: new FormControl(false),
      agree: new FormControl(null, [Validators.required]),
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
    this.mainForm.controls.showPassword.valueChanges.subscribe({
      next: (val) => {
        this.passwordType = val === true ? 'text' : 'password';
      }
    });
    this.mainForm.controls.showPasswordConfirm.valueChanges.subscribe({
      next: (val) => {
        this.passwordConfirmType = val === true ? 'text' : 'password';
      }
    });
    // console.log(this.orgCampaignDetails);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.legal = this.personPrefill.AgreementContent;
  }

  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = regex.test(control.value);
      return valid ? null : error;
    };
  }

  initData() {

  }

  goToNextPage() {
    this.processData();
  }

  processData() {
    this.personPrefill.Password = this.mainForm.get('password').value;
    this.updateData.emit(this.personPrefill);
    this.isSaving = true;
    this.submitPrefillPaymentData();
  }

  submitPrefillPaymentData() {
    this.organizationService.submitPersonOrganizationRegistrationPrefillData(this.personPrefill)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.isSaving = false;
          this.next.emit();
        }, error: (e) => {
          if (e?.error?.Message) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: e.error.Message.replace('UM: ', ''), life: 5000});
          } else {
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Our apologies... An error occurred. Please try again and let us know if it continues. Thank you!'});
          }
          this.isSaving = false;
          console.debug(e);
        }
      });
  }
}
